<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaVisitas"
      :titulo="$t ('Visitas')"
      icono="mdi-badge-account-outline"
      tabla="visempinq"
      :campos="['loc+', 'fecalt-', 'id_empinq', 'id_tippas-', 'id_zon-', 'inival', 'finval', 'nom', 'nif-', 'emp', 'mat', 'corele-', 'obs-', 'plaasi', 'fechorent-', 'fechorsal-']"
      :campos-filtrables="['inival', 'id_empinq', 'id_zon']"
      :parametros="parametros"
      :objeto-definicion-campos="dc"
      :objeto-registro-formulario="rf"
      busqueda-rapida
      :titulo-crud="$t ('visita')"
      campo-sujeto-accion="loc"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
      :evento-antes-abrir-formulario-datos="antesAbrirFormulario"
      :item-class="obtenerItemClassTablaDatos"
      :formulario-datos-api-props="{ anchoMaximo: '450' }"
      :ocultar-rejilla="tabSeleccionado == 0"
    >
      <template v-slot:debajo-titulo>
        <v-tabs fixed-tabs background-color="#D7CCD7" v-model="tabSeleccionado" style="width: 100%" mobile-breakpoint="0" @change="actualizarDatos">
          <v-tab v-for="tab in arrayTabs" :class="tab.class" :key="tab.titulo"><v-icon class="mr-2">{{tab.icono}}</v-icon>{{ $t (tab.titulo) }}</v-tab>
        </v-tabs>

        <div v-show="tabSeleccionado == 0" class="pa-3">
          <v-calendar
            :weekdays="[1, 2, 3, 4, 5, 6, 0]"
            :events="eventosCalendario"
            :short-months="false"
            :short-weekdays="true"
            @click:date="clickFechaCalendario"
            style="height: 70vh"
          >
          </v-calendar>
        </div>
      </template>

      <template v-slot:[`item.loc`]="{ item }">
          <span class="localizador">{{ item.loc }}</span>
      </template>

      <template v-slot:[`item.mat`]="{ item }">
        <template v-if="item.mat">
          <span class="matricula">{{ item.mat }}</span>
        </template>
      </template>

      <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
        <CampoFormularioDatos v-if="accionCrud != 'C'" nombre-campo="fecalt" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" disabled />
        <CampoFormularioDatos v-if="definicionCampos['id_empinq'].visibilidad==''" nombre-campo="id_empinq" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="accionCrud != 'C'" @change="changeSelectEmpresaInquilina" />
        <CampoFormularioDatos ref="id_tippas" nombre-campo="id_tippas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="accionCrud != 'C'" @change="changeSelectTipoPase" />
        <CampoFormularioDatos v-show="datosRegistro['id_tippas'] && Object.keys (definicionCampos['id_zon'].dominio_valores).length > 1" ref="id_zon" nombre-campo="id_zon" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="actualizarSelectPlazasDisponibles" />
        <CampoFormularioDatos :min="fechaActual" :max="fechaMaximaInicioVisita" nombre-campo="inival" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :ajustar-segundos="0" :ajustar-milisegundos="0" hora-por-defecto="00:00" @change="changeFechaInicio" />
        <CampoFormularioDatos :min="fechaMinimaFinVisita" :max="fechaDentroTresMeses" nombre-campo="finval" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :ajustar-segundos="59" :ajustar-milisegundos="998" hora-por-defecto="23:59" @change="actualizarSelectPlazasDisponibles" />
        <CampoFormularioDatos nombre-campo="nom" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos nombre-campo="ape" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos nombre-campo="emp" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos nombre-campo="mat" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" prepend-inner-icon="mdi-car" :inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 12 }" />
        <CampoFormularioDatos nombre-campo="corele" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos nombre-campo="obs" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos nombre-campo="plaasi" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos v-if="accionCrud != 'C'" nombre-campo="fechorent" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" disabled />
        <CampoFormularioDatos v-if="accionCrud != 'C'" nombre-campo="fechorsal" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" disabled />
      </template>

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from "@/components/CampoFormularioDatos.vue";
import { DateTime } from "luxon";
import api from '@/api'
import { cadenaAColor } from "@/util";

export default {
  components: { TablaDatosAPI,
                CampoFormularioDatos
                },
  data() {
    return {
      vista: "calendario",
      eventosCalendario: [],
      arrayTabs: [
        { titulo: "Calendario", icono: "mdi-calendar-blank", parametro: "" },
        { titulo: "Anteriores", icono: "mdi-calendar-arrow-left", parametro: "filtroAnteriores" },
        { titulo: "Ahora", icono: "mdi-calendar-today", parametro: "filtroAhora" },
        { titulo: "Próximas", icono: "mdi-calendar-arrow-right", parametro: "filtroProximas" },
        { titulo: "(Todas)", icono: "mdi-calendar-blank-multiple", parametro: "" },
      ],
      tabSeleccionado: 1,
      dc: {},
      rf: {}
    }
  },
  methods: {
    actualizarDatos(){
      if (this.tabSeleccionado == 0) {
        this.actualizarCalendario();
      } else {
        this.$nextTick (() => {
          this.$refs.tablaVisitas.actualizarDatosPorCambiosEnBusqueda();
        });
      }
    },
    antesAbrirFormulario () {
      this.changeSelectEmpresaInquilina (this.rf ["id_empinq"]);
    },
    obtenerItemClassTablaDatos (item) {
      if (DateTime.fromFormat (item.inival, "yyyy-MM-dd HH:mm:ss").diffNow() > 0)
        return "visita_proxima";
      else if (DateTime.fromFormat (item.finval, "yyyy-MM-dd HH:mm:ss").diffNow() < 0)
        return "visita_anterior";
    },
    changeSelectEmpresaInquilina () {
      this.dc ['id_tippas'].dominio_valores = {};
      this.dc ['id_zon'].dominio_valores = {};
      this.inicializarSelectPlazasDisponibles ();

      if (this.rf ['id_empinq']) {
        // debemos actualizar el select de "tipos de pases" cada vez que cambiemos el select de "empresa inquilina"
        api.obtenerTiposPases({ _contexto: 'gestion_visitas', id_empinq: this.rf ['id_empinq'] })
          .then ( (respuesta) => {
            respuesta.data.filas.forEach (fila => {
              this.dc ['id_tippas'].dominio_valores [fila.id_tippas] = fila._des;
            });
          })
          .finally (() => {
            this.$refs['id_tippas'].actualizarItemsSelect();

            this.$nextTick (() => { // usamos "$nextTick" para ejecutar lo siguiente después de que se hayan actualizado los items del select
              let ids_tipos_pases = Object.keys (this.dc ['id_tippas'].dominio_valores);
              if (ids_tipos_pases.length == 1)
                this.$set (this.rf, 'id_tippas', JSON.parse (ids_tipos_pases [0]));

              this.changeSelectTipoPase ();
              this.log (this.rf);
            });
          });
      } else if (this.$refs['id_tippas']) {
        this.$refs['id_tippas'].actualizarItemsSelect();
        this.$refs['id_zon'].actualizarItemsSelect();
        this.$refs['plaasi'][0].actualizarItemsSelect();
      }
    },
    changeSelectTipoPase () {
      this.dc ['id_zon'].dominio_valores = {};
      this.inicializarSelectPlazasDisponibles ();

      if (this.rf ['id_empinq'] && this.rf ['id_tippas']) {
        // debemos actualizar el select de "zonas" cada vez que cambiemos el select de "tipo de pase"
        api.obtenerZonasAccesoTipoPase({ id_tippas: this.rf ['id_tippas'] })
          .then ( (respuesta) => {
            respuesta.data.filas.forEach (fila => {
              this.dc ['id_zon'].dominio_valores [fila.id_zon] = fila.des + (fila.nomins ? ' - ' + fila.nomins : '');
            });
          })
          .finally (() => {
            this.$refs['id_zon'].actualizarItemsSelect();

            this.$nextTick (() => { // usamos "$nextTick" para ejecutar lo siguiente después de que se hayan actualizado los items del select
              let ids_zonas = Object.keys (this.dc ['id_zon'].dominio_valores);
              if (ids_zonas.length == 1)
                this.$set (this.rf, 'id_zon', JSON.parse (ids_zonas [0]));

              this.actualizarSelectPlazasDisponibles();
            });
          });
      } else if (this.$refs['id_zon']) {
        this.$refs['id_zon'].actualizarItemsSelect();
        this.$refs['plaasi'][0].actualizarItemsSelect();
      }
    },
    inicializarSelectPlazasDisponibles () {
      this.dc ['plaasi'].valores = {};
      this.dc ['plaasi'].valores ['"-"'] = '(Asignar automáticamente)';
    },
    changeFechaInicio(){
      if (this.rf ["finval"] == undefined)
        this.$set (this.rf, 'finval', DateTime.fromFormat (this.rf ["inival"], "yyyy-MM-dd HH:mm:ss").endOf('day').toFormat ("yyyy-MM-dd HH:mm:ss"));
      this.actualizarSelectPlazasDisponibles();
    },
    actualizarSelectPlazasDisponibles () {
      this.inicializarSelectPlazasDisponibles ();

      if (this.rf ['id_empinq'] && this.rf ['id_tippas'] && this.rf ['id_zon'] && this.rf ['inival'] && this.rf ['finval']) {
        api.obtenerGestionVisitasPlazasDisponibles ({ id_empinq: this.rf ['id_empinq'],
                                                      id_tippas: this.rf ['id_tippas'],
                                                      id_zon: this.rf ['id_zon'],
                                                      inival: this.rf ['inival'],
                                                      finval: this.rf ['finval'],
                                                      id_visempinq: this.rf ['id_visempinq'] })
          .then ( (respuesta) => {
            respuesta.data.plazas_disponibles.forEach (plaza => {
              this.dc ['plaasi'].valores [JSON.stringify (plaza)] = plaza;
            });
            if (!respuesta.data.plazas_disponibles.includes (this.rf ['plaasi']))
              this.$set (this.rf, 'plaasi', '-');
          })
          .finally ( () => {
            this.$refs['plaasi'][0].actualizarItemsSelect();
          });
      } else if (this.$refs['plaasi']) {
        this.$refs['plaasi'][0].actualizarItemsSelect();
      }
    },
    actualizarCalendario() {
      api.obtenerRegistrosTablaVista ('visempinq', { })
        .then ((respuesta) => {
          // console.log(respuesta);
          this.eventosCalendario = [];
          respuesta.data.filas.forEach ((visita) => {
            this.eventosCalendario.push ({
              id: visita.id_visempinq,
              name: visita.emp ?? (visita.nom ?? '' + ' ' + visita.ape ?? ''),
              start: visita.inival,
              end: visita.finval,
              color: cadenaAColor (visita.emp, 50, 60),
              timed: false,
            })
          });
        });
    },
    clickFechaCalendario(fecha){
      this.$refs.tablaVisitas.anadirRegistro({
        inival: fecha.date,
        finval: fecha.date
      });
    }
  },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gesvisempinq");
    },
    parametros() {
      let aux = {};
      if (this.arrayTabs [this.tabSeleccionado].parametro)
        aux [this.arrayTabs [this.tabSeleccionado].parametro] = { valor: 1, descripcion: this.arrayTabs [this.tabSeleccionado].titulo };
      return aux;
    },
    fechaActual() {
      return DateTime.local().toISODate();
    },
    fechaDentroTresMeses() {
      return DateTime.local().plus({ months: 3 }).toISODate();
    },
    fechaMaximaInicioVisita() {
      if (this.rf ['finval'])
        return DateTime.fromFormat (this.rf ['finval'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return this.fechaDentroTresMeses;
    },
    fechaMinimaFinVisita() {
      if (this.rf ['inival'])
        return DateTime.fromFormat (this.rf ['inival'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return DateTime.local().toISODate();
    }
  },
  created() {
    if (!this.$store.operador.empresaInquilina.nombre && !this.$store.datos.id_empresa_inquilina_seleccionada)
      this.arrayTabs[0].class = "d-none";
    this.tabSeleccionado = this.$store.leer_preferencia ('tabSeleccionado', 1, 'gestion_visitas');
  },
  watch: {
    tabSeleccionado() {
      this.$store.guardar_preferencia ('tabSeleccionado', this.tabSeleccionado, 1, 'gestion_visitas');
    }
  }
};
</script>

<style>
  .visita_anterior {
    color: #7E57C2;
  }
  .visita_proxima {
    color: #689F38;
  }
</style>